import React from "react";
import Header from "./Header"
import MenuSliderBar from "../slider/menubarSlider";
import SiderDrawer from "../../components/SIdeDrawer/SideDrawer";
import SiderDrawerFilter from "../../components/SIdeDrawer/SideDrawer1";
import Backdrop from '../../components/Backdrop/Backdrop';
import { OPEN_FILTER_DRAWER_EVENT } from "../../components/SIdeDrawer/drawerFilterSlot";
import { isProviderEcosystemPath } from "../../components/SIdeDrawer/drawerNavConfig";


class Sidebar  extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sideDrawerOpen: false,
            sideDrawerOpen1: false
        }
    };

    // Pages (e.g. the Provider catalog's "Filters" button) can ask the Filter drawer to open.
    openFilterDrawer = () => this.setState({ sideDrawerOpen1: true });

    componentDidMount() {
        window.addEventListener(OPEN_FILTER_DRAWER_EVENT, this.openFilterDrawer);
    }

    componentWillUnmount() {
        window.removeEventListener(OPEN_FILTER_DRAWER_EVENT, this.openFilterDrawer);
    }

    drawerToggleClickHander = () => {
        this.setState((prevState) => {
          
            return { sideDrawerOpen: !prevState.sideDrawerOpen }
        })
    }

    drawerToggleClickFilter = () => {
        this.setState((prevState) => {
            return { sideDrawerOpen1: !prevState.sideDrawerOpen }
        })
    }

    drawerToggleClickAddToDeal = () => {
        this.setState((prevState) => {
            
            return { sideDrawerOpen: !prevState.sideDrawerOpen }
        })
    }

    dackdropClickHander = () => {
        // A shop page that does not manage a filterShop state (Provider Shop) passes no setter.
        this.props.userShop && typeof this.props.setFilterShop === "function" && this.props.setFilterShop(false)
        this.setState({ sideDrawerOpen: false });
        this.setState({ sideDrawerOpen1: false });
    }

    render() {
          const {
             SliderPunShow,
            categoriesID,
            handleFilters,
            prices,
            setMyFilters, 
            infoSource,
            AllCategorie,
            filterShop,
            getCalFilShop,
            userShop = false,
            outOffPage = false,
            allHeaderShop,
            infoHeaderShop = null,
            inpage,
            propsFIlter,
            showFilterMenu = true,
            pageTopRef,
            subnavMessages,
            subnavCategoryTitles,
            subnavPreviousCategoryTitle,
            subnavPreviousCategoryLink
        } = this.props
        // let sideDrawer
        let backdrop
        const {
        sideDrawerOpen, 
        sideDrawerOpen1
        }= this.state
        // Provider / Dropshipping In pages: the Filter drawer brings its own full-viewport backdrop (mounted on <body>);
        // the legacy in-page Backdrop is absolutely positioned inside the scrolling page and only adds a second,
        // scroll-offset overlay there. Every other page keeps the legacy behaviour untouched.
        const filterDrawerOnly = !this.state.sideDrawerOpen && (this.state.sideDrawerOpen1 || filterShop) && isProviderEcosystemPath(window.location.pathname);
        if (!filterDrawerOnly && (this.state.sideDrawerOpen || this.state.sideDrawerOpen1 || filterShop)) {
            backdrop = <Backdrop click={this.dackdropClickHander} />
        }

        return (
            <div   >
                 {outOffPage ?
                 allHeaderShop(this.drawerToggleClickHander)
                 :
                <Header 
                infoSource={infoSource} 
                pageTopRef={pageTopRef}
                drawerClickHander={this.drawerToggleClickHander} 
               {...infoSource?.allSettings?.header}
                />
                }

                <MenuSliderBar
                    infoSource={infoSource}
                    sliderShow={showFilterMenu}
                    drawerClickHander={this.drawerToggleClickFilter}
                    messages={subnavMessages}
                    categoryTitles={subnavCategoryTitles}
                    previousCategoryTitle={subnavPreviousCategoryTitle}
                    previousCategoryLink={subnavPreviousCategoryLink}
                    showFilterMenu={showFilterMenu}
                    headerOwnsMobileMenu={!outOffPage}
                />
                <SiderDrawer infoSource={infoSource}  show={this.state.sideDrawerOpen} click={this.dackdropClickHander} {...infoSource?.allSettings?.drawer} />
                {showFilterMenu && (
                    <SiderDrawerFilter
                        AllCategorie={AllCategorie}
                        infoSource={infoSource}
                        show={this.state.sideDrawerOpen1}
                        filterShop={filterShop}
                        SliderPunShow={SliderPunShow}
                        categoriesID={categoriesID}
                        handleFilters={handleFilters}
                        click={this.dackdropClickHander}
                        prices={prices}
                        setMyFilters={setMyFilters}
                        getCalFilShop={getCalFilShop}
                        userShop={userShop}
                        inpage={inpage}
                        propsFIlter={propsFIlter}
                    />
                )}

                {backdrop}
            </div>
        )
} }

export default Sidebar;
